export enum CommodityLineItemsFormNames {
  Commodities = 'commodities',
  LineItemClaimAmount = 'lineItemClaimAmount',
  EnteredClaimAmount = 'enteredClaimAmount',
  TotalLiabilityAndFreight = 'totalLiabilityAndFreight',
}
